<label class="label-form-control select-label">
  {{ menu.label }}
</label>
<div class="form-control form-control-sm select-form-control" [matMenuTriggerFor]="matMenu">
  <div class="display">{{ selectedMenuItem.label | labelOrCustom: shortcutType }}</div>
  <capra-icon class="select-icon" icon="icon-caret-down"></capra-icon>
</div>
<mat-menu #matMenu="matMenu" class="select-menu">
  <ng-template matMenuContent>
    <button mat-menu-item class="format-shortcut-menu-item" *ngFor="let item of menu.options" (click)="selectItem(item)"
      [autofocus]="item === selectedMenuItem" [disabled]="item.disabled">
      <span [class.selected]="shortcutType !=='custom' && item === selectedMenuItem">
        <span class="indicator-icon"></span><span class="shortcut-menu-item-text"> {{ item.label }}</span>
      </span>
      <span *ngIf="item.example" class="format-shortcut-example">
        {{ item.example }}
      </span>
    </button>
    <ng-container *ngIf="menu.type !== 'PlainText'">
      <hr class="divider" />
      <button class="format-shortcut-menu-item" (click)="showMoreFormats()" mat-menu-item>
        <span [class.selected]="shortcutType ==='custom'">
          <span class="indicator-icon"></span>
          <span class="shortcut-menu-item-text"> More formats... </span>
        </span>
      </button>
    </ng-container>
  </ng-template>
</mat-menu>